import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_23HourStabilizationSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_23HourStabilizationSra' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>The Department of Medical Assistance Services <br />
                    ADDICTION AND RECOVERY TREATMENT SERVICES (ARTS) AND <br />
                    MENTAL HEALTH SERVICES (MHS) REGISTRATION FORM</h3></center> <br />
                    The information on this form must be submitted to the member's plan.<b>Each requested service must be submitted
                        separately. Multiple services cannot be registered on the same form.</b></p> <br />


                <p className='w-750'><h4>MEMBER INFORMATION</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberAddress' name='txtMemberAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>State:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Zip:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPhone' name='txtMemberPhone' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Name(if applicable):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Phone# (if applicable):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardianName' name='txtParentGuardianName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardianPhone' name='txtParentGuardianPhone' className='add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><h4>PROVIDER INFORMATION</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' placeholder='Richmond' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' placeholder='Virginia' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' defaultValue={23224} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Fax #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' defaultValue={8044823767} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactPhone' name='txtClinicalContactPhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* This is the individual to whom the Health Plan can reach out to answer additional clinical questions.</b></p> <br />



                <p className='w-750'><center><h4>CRISIS CALL CENTER INFORMATION <br />
                    <span className='small'>(Mobile Crisis Response Only)</span></h4></center>
                    <span className='eleHeader'>Data Platform Reference #:</span>
                    <input type='text' id='txtDataPlatformReference' name='txtDataPlatformReference' className='add-only' /></p>

                <p className='w-750'><center><h4>SERVICE INFORMATION <br />
                    <span className='small'>(Time of admission is only required for Crisis Services)</span></h4></center>
                    <span className='eleHeader'>Requested Service:</span>
                    <select id='ddlRequestedService' name='ddlRequestedService' className='add-only'>
                        <option value='NA'></option>
                        <option value='Crisis'>23-Hour Crisis Stabilization (S9485)</option>
                        <option value='PeerOne'>ARTS Peer Recovery Support Services-Group (S9445)</option>
                        <option value='PeerTwo'>ARTS Peer Recovery Support Services-Individual (T1012)</option>
                        <option value='MentalHealthOne'>Mental Health Case Management (H0023)</option>
                        <option value='MentalHelathTwo'>Mental Health Peer Recovery Support Services-Group (H0025)</option>
                        <option value='MentalHelathThree'>Mental Health Peer Recovery Support Services-Individual (H0024)</option>
                        <option value='Mobile'>Mobile Crisis Response (H2011)</option>
                        <option value='MobileOne'>Mobile Crisis Response (H2011): Prescreen Only</option>
                        <option value='ResidentialOne'>Residential Crisis Stabilization Unit (H2018)</option>
                        <option value='SubstanceUse'>Substance Use Case Management (H0006)</option>
                    </select></p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Requested Start Date</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>Time of Admission</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>Requested End Date:</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>Requested Units:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='date' id='txtRequestedStartDate' name='txtRequestedStartDate' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='time' id='txtTimeOfAdmission' name='txtTimeOfAdmission' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtRequestedEndDate' name='txtRequestedEndDate' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id='txtRequestedUnits' name='txtRequestedUnits' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>CLINICAL INFORMATION</h4></center>

                    <span className='eleHeader'>Primary Diagnosis:</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis:</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /></p>

                <p className='w-750'><center><h4>ADDITIONAL INFORMATION</h4></center>
                    <b>If requesting Mental Health Case Management or Substance Use Case Management for an individual that is (or will be)
                        participating in Assertive Community Treatment (H0040), please provide the following:
                    </b><br />
                    1. Evidence of how the provision of both services will not be a duplication of service <br />
                    2. Identify treatment goals for the case management services and how these goals will be different from the goals for Assertive
                    Community Treatment. <br />
                    3. Evidence that the individual participating in the service has been provided education on case management services and the
                    service components of Assertive Community Treatment and the individual is requesting separate case management service.</p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtMember' name='txtMember' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>


























            </div >
        </form >

    )
}











